<router-outlet></router-outlet>
<app-mu-chat></app-mu-chat>
<div class="versionapp">
  <span>{{ appVersion }}</span>
</div>
